<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent width="90%">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="hidden-sm-and-down" v-bind="attrs" v-on="on" color="primary" dark
          alt="Incluir Previsão" @click="abrirCadastro()" title="Incluir Previsão">
          <v-icon>add</v-icon>Incluir
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Incluir Previsão de Quadro Horário</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout align-center row fill-height>
              <v-flex xs12 sm6 md4>
                <v-select v-model="idTipoFuncao" :items="tiposFuncao" item-text="nome" item-value="id"
                  label="Filtrar por Função" clearable @change="carregarFuncionarios"></v-select>
              </v-flex>
            </v-layout>
            <v-data-table :loading="loading" :headers="headers" :items="funcionarios"
              class="elevation-1" hide-actions>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.numeroRegistro }}</td>
                <td>{{ props.item.nome }}</td>
                <td>{{ props.item.funcao }}</td>
                <td>
                  <v-text-field type="number" min="0" v-model.number="props.item.qhDom" hide-details single-line dense></v-text-field>
                </td>
                <td>
                  <v-text-field type="number" min="0" v-model.number="props.item.qhSeg" hide-details single-line dense></v-text-field>
                </td>
                <td>
                  <v-text-field type="number" min="0" v-model.number="props.item.qhTer" hide-details single-line dense></v-text-field>
                </td>
                <td>
                  <v-text-field type="number" min="0" v-model.number="props.item.qhQua" hide-details single-line dense></v-text-field>
                </td>
                <td>
                  <v-text-field type="number" min="0" v-model.number="props.item.qhQui" hide-details single-line dense></v-text-field>
                </td>
                <td>
                  <v-text-field type="number" min="0" v-model.number="props.item.qhSex" hide-details single-line dense></v-text-field>
                </td>
                <td>
                  <v-text-field type="number" min="0" v-model.number="props.item.qhSab" hide-details single-line dense></v-text-field>
                </td>
              </template>
              <template slot="no-data">
                Não há funcionários disponíveis para inclusão neste plano.
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click.native="close">Cancelar</v-btn>
          <v-btn color="primary" type="submit" @click.native="confirmar" dark>Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import qhPrevisaoService from "@/service/qh/QhPrevisaoService";
export default {
  name: "ModalInclusaoQhPrevisao",
  props: {
    idPlano: Number
  },
  data() {
    return {
      dialog: false,
      loading: false,
      funcionarios: [],
      tiposFuncao: [],
      idTipoFuncao: null,
      itensEditados: {},
      headers: [
        { text: "Nr Registro", align: "left", sortable: false, value: "numeroRegistro" },
        { text: "Nome", align: "left", sortable: false, value: "nome" },
        { text: "Função", align: "left", sortable: false, value: "funcao" },
        { text: "Dom", align: "center", sortable: false, value: "qhDom" },
        { text: "Seg", align: "center", sortable: false, value: "qhSeg" },
        { text: "Ter", align: "center", sortable: false, value: "qhTer" },
        { text: "Qua", align: "center", sortable: false, value: "qhQua" },
        { text: "Qui", align: "center", sortable: false, value: "qhQui" },
        { text: "Sex", align: "center", sortable: false, value: "qhSex" },
        { text: "Sab", align: "center", sortable: false, value: "qhSab" }
      ]
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  methods: {
    async abrirCadastro() {
      this.loading = true;
      this.itensEditados = {};
      // RN009.1: combo lista apenas as funções dos funcionários elegíveis ao plano.
      this.tiposFuncao = await qhPrevisaoService.listarFuncoesDisponiveis(this.idPlano);
      await this.carregarFuncionarios();
      this.loading = false;
    },
    async carregarFuncionarios() {
      this.persistirEdicoes();
      this.loading = true;
      const lista = await qhPrevisaoService.listarFuncionariosDisponiveis(
        this.idPlano,
        this.idTipoFuncao
      );
      this.funcionarios = (lista || []).map(f => this.aplicarEdicoes(f));
      this.loading = false;
    },
    persistirEdicoes() {
      this.funcionarios.forEach(f => {
        if (this.algumDiaMaiorQueZero(f)) {
          this.itensEditados[f.idFuncionario] = {
            qhDom: f.qhDom,
            qhSeg: f.qhSeg,
            qhTer: f.qhTer,
            qhQua: f.qhQua,
            qhQui: f.qhQui,
            qhSex: f.qhSex,
            qhSab: f.qhSab
          };
        }
      });
    },
    aplicarEdicoes(funcionario) {
      const editado = this.itensEditados[funcionario.idFuncionario];
      if (editado) {
        funcionario.qhDom = editado.qhDom;
        funcionario.qhSeg = editado.qhSeg;
        funcionario.qhTer = editado.qhTer;
        funcionario.qhQua = editado.qhQua;
        funcionario.qhQui = editado.qhQui;
        funcionario.qhSex = editado.qhSex;
        funcionario.qhSab = editado.qhSab;
      }
      return funcionario;
    },
    confirmar() {
      this.persistirEdicoes();
      const itens = Object.keys(this.itensEditados).map(idFuncionario => ({
        idFuncionario: parseInt(idFuncionario, 10),
        ...this.itensEditados[idFuncionario]
      }));
      if (itens.length === 0) {
        this.close();
        return;
      }
      qhPrevisaoService.incluirLote(this.idPlano, itens).then(retorno => {
        if (retorno !== undefined) {
          this.$emit("qhPrevisaoCadastrada", true);
          this.close();
        }
      });
    },
    algumDiaMaiorQueZero(item) {
      return (
        item.qhDom > 0 ||
        item.qhSeg > 0 ||
        item.qhTer > 0 ||
        item.qhQua > 0 ||
        item.qhQui > 0 ||
        item.qhSex > 0 ||
        item.qhSab > 0
      );
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.funcionarios = [];
        this.idTipoFuncao = null;
        this.itensEditados = {};
      }, 300);
    }
  }
};
</script>
